import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/searchPOIs'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class searchPOIsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "searchPOIsStore",
			variables: true,
		})
	}
}

export async function load_searchPOIs(params) {
  await initClient()

	const store = new searchPOIsStore()

	await store.fetch(params)

	return {
		searchPOIs: store,
	}
}
